module.exports = __webpack_public_path__ + "img/money.31a92947.png";